/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * Timefill API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  GetVersion200,
  PasswordResetRequestBody,
  ResetPasswordBody,
  SignIn200,
  SignIn401,
  SignInBody,
  SignUp200,
  SignUp422,
  SignUpBody,
  UpdateAccountBody
} from './schemas';

import { axios } from '../../config/axios';
/**
 * メールアドレスとパスワードでログインし、認証トークンを発行します。
 * @summary ログイン（サインイン）
 */
export const signIn = (
    signInBody: SignInBody,
 signal?: AbortSignal
) => {
      
      
      return axios<SignIn200>(
      {url: `/auth/sign_in`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: signInBody, signal
    },
      );
    }
  


export const getSignInMutationOptions = <TError = SignIn401,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof signIn>>, TError,{data: SignInBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof signIn>>, TError,{data: SignInBody}, TContext> => {

const mutationKey = ['signIn'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof signIn>>, {data: SignInBody}> = (props) => {
          const {data} = props ?? {};

          return  signIn(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SignInMutationResult = NonNullable<Awaited<ReturnType<typeof signIn>>>
    export type SignInMutationBody = SignInBody
    export type SignInMutationError = SignIn401

    /**
 * @summary ログイン（サインイン）
 */
export const useSignIn = <TError = SignIn401,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof signIn>>, TError,{data: SignInBody}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof signIn>>,
        TError,
        {data: SignInBody},
        TContext
      > => {

      const mutationOptions = getSignInMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * 現在のアクセストークンが有効かどうかを検証します。
 * @summary トークン検証（有効性チェック）
 */
export const validateToken = (
    
 signal?: AbortSignal
) => {
      
      
      return axios<void>(
      {url: `/auth/validate_token`, method: 'GET', signal
    },
      );
    }
  



export const getValidateTokenQueryKey = () => {
    return [
    `/auth/validate_token`
    ] as const;
    }

    
export const getValidateTokenQueryOptions = <TData = Awaited<ReturnType<typeof validateToken>>, TError = void>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof validateToken>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getValidateTokenQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof validateToken>>> = ({ signal }) => validateToken(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof validateToken>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ValidateTokenQueryResult = NonNullable<Awaited<ReturnType<typeof validateToken>>>
export type ValidateTokenQueryError = void


export function useValidateToken<TData = Awaited<ReturnType<typeof validateToken>>, TError = void>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof validateToken>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof validateToken>>,
          TError,
          Awaited<ReturnType<typeof validateToken>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useValidateToken<TData = Awaited<ReturnType<typeof validateToken>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof validateToken>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof validateToken>>,
          TError,
          Awaited<ReturnType<typeof validateToken>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useValidateToken<TData = Awaited<ReturnType<typeof validateToken>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof validateToken>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary トークン検証（有効性チェック）
 */

export function useValidateToken<TData = Awaited<ReturnType<typeof validateToken>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof validateToken>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getValidateTokenQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * 現在の認証トークンを無効化し、サインアウトします。
 * @summary ログアウト（サインアウト）
 */
export const signOut = (
    
 ) => {
      
      
      return axios<void>(
      {url: `/auth/sign_out`, method: 'DELETE'
    },
      );
    }
  


export const getSignOutMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof signOut>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof signOut>>, TError,void, TContext> => {

const mutationKey = ['signOut'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof signOut>>, void> = () => {
          

          return  signOut()
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SignOutMutationResult = NonNullable<Awaited<ReturnType<typeof signOut>>>
    
    export type SignOutMutationError = void

    /**
 * @summary ログアウト（サインアウト）
 */
export const useSignOut = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof signOut>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof signOut>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getSignOutMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * メールアドレスとパスワードで新規ユーザーを作成します。
 * @summary ユーザー登録（サインアップ）
 */
export const signUp = (
    signUpBody: SignUpBody,
 signal?: AbortSignal
) => {
      
      
      return axios<SignUp200>(
      {url: `/auth`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: signUpBody, signal
    },
      );
    }
  


export const getSignUpMutationOptions = <TError = SignUp422,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof signUp>>, TError,{data: SignUpBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof signUp>>, TError,{data: SignUpBody}, TContext> => {

const mutationKey = ['signUp'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof signUp>>, {data: SignUpBody}> = (props) => {
          const {data} = props ?? {};

          return  signUp(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SignUpMutationResult = NonNullable<Awaited<ReturnType<typeof signUp>>>
    export type SignUpMutationBody = SignUpBody
    export type SignUpMutationError = SignUp422

    /**
 * @summary ユーザー登録（サインアップ）
 */
export const useSignUp = <TError = SignUp422,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof signUp>>, TError,{data: SignUpBody}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof signUp>>,
        TError,
        {data: SignUpBody},
        TContext
      > => {

      const mutationOptions = getSignUpMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * ログイン中ユーザーのアカウント情報（メール/パスワード）を更新します。パスワード変更時は current_password が必須です。
 * @summary アカウント更新
 */
export const updateAccount = (
    updateAccountBody: UpdateAccountBody,
 ) => {
      
      
      return axios<void>(
      {url: `/auth`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateAccountBody
    },
      );
    }
  


export const getUpdateAccountMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAccount>>, TError,{data: UpdateAccountBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateAccount>>, TError,{data: UpdateAccountBody}, TContext> => {

const mutationKey = ['updateAccount'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateAccount>>, {data: UpdateAccountBody}> = (props) => {
          const {data} = props ?? {};

          return  updateAccount(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateAccountMutationResult = NonNullable<Awaited<ReturnType<typeof updateAccount>>>
    export type UpdateAccountMutationBody = UpdateAccountBody
    export type UpdateAccountMutationError = void

    /**
 * @summary アカウント更新
 */
export const useUpdateAccount = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAccount>>, TError,{data: UpdateAccountBody}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateAccount>>,
        TError,
        {data: UpdateAccountBody},
        TContext
      > => {

      const mutationOptions = getUpdateAccountMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * ログイン中ユーザーのアカウントを削除します。
 * @summary アカウント削除（退会）
 */
export const destroyAccount = (
    
 ) => {
      
      
      return axios<void>(
      {url: `/auth`, method: 'DELETE'
    },
      );
    }
  


export const getDestroyAccountMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyAccount>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof destroyAccount>>, TError,void, TContext> => {

const mutationKey = ['destroyAccount'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof destroyAccount>>, void> = () => {
          

          return  destroyAccount()
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DestroyAccountMutationResult = NonNullable<Awaited<ReturnType<typeof destroyAccount>>>
    
    export type DestroyAccountMutationError = void

    /**
 * @summary アカウント削除（退会）
 */
export const useDestroyAccount = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyAccount>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof destroyAccount>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getDestroyAccountMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * パスワード再設定メールを送信します。redirect_url が必要です。
 * @summary パスワードリセット要求
 */
export const passwordResetRequest = (
    passwordResetRequestBody: PasswordResetRequestBody,
 signal?: AbortSignal
) => {
      
      
      return axios<void>(
      {url: `/auth/password`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: passwordResetRequestBody, signal
    },
      );
    }
  


export const getPasswordResetRequestMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof passwordResetRequest>>, TError,{data: PasswordResetRequestBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof passwordResetRequest>>, TError,{data: PasswordResetRequestBody}, TContext> => {

const mutationKey = ['passwordResetRequest'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof passwordResetRequest>>, {data: PasswordResetRequestBody}> = (props) => {
          const {data} = props ?? {};

          return  passwordResetRequest(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PasswordResetRequestMutationResult = NonNullable<Awaited<ReturnType<typeof passwordResetRequest>>>
    export type PasswordResetRequestMutationBody = PasswordResetRequestBody
    export type PasswordResetRequestMutationError = void

    /**
 * @summary パスワードリセット要求
 */
export const usePasswordResetRequest = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof passwordResetRequest>>, TError,{data: PasswordResetRequestBody}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof passwordResetRequest>>,
        TError,
        {data: PasswordResetRequestBody},
        TContext
      > => {

      const mutationOptions = getPasswordResetRequestMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * リセットトークン（reset_password_token）でパスワードを再設定します。認証ヘッダは不要です。
 * @summary パスワード再設定（トークン）
 */
export const resetPassword = (
    resetPasswordBody: ResetPasswordBody,
 ) => {
      
      
      return axios<void>(
      {url: `/auth/password`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: resetPasswordBody
    },
      );
    }
  


export const getResetPasswordMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetPassword>>, TError,{data: ResetPasswordBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof resetPassword>>, TError,{data: ResetPasswordBody}, TContext> => {

const mutationKey = ['resetPassword'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resetPassword>>, {data: ResetPasswordBody}> = (props) => {
          const {data} = props ?? {};

          return  resetPassword(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ResetPasswordMutationResult = NonNullable<Awaited<ReturnType<typeof resetPassword>>>
    export type ResetPasswordMutationBody = ResetPasswordBody
    export type ResetPasswordMutationError = unknown

    /**
 * @summary パスワード再設定（トークン）
 */
export const useResetPassword = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetPassword>>, TError,{data: ResetPasswordBody}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof resetPassword>>,
        TError,
        {data: ResetPasswordBody},
        TContext
      > => {

      const mutationOptions = getResetPasswordMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * 現在のアプリケーションのバージョンを返します。
 * @summary バージョン情報の取得
 */
export const getVersion = (
    
 signal?: AbortSignal
) => {
      
      
      return axios<GetVersion200>(
      {url: `/version`, method: 'GET', signal
    },
      );
    }
  



export const getGetVersionQueryKey = () => {
    return [
    `/version`
    ] as const;
    }

    
export const getGetVersionQueryOptions = <TData = Awaited<ReturnType<typeof getVersion>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVersion>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVersionQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVersion>>> = ({ signal }) => getVersion(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getVersion>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetVersionQueryResult = NonNullable<Awaited<ReturnType<typeof getVersion>>>
export type GetVersionQueryError = unknown


export function useGetVersion<TData = Awaited<ReturnType<typeof getVersion>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVersion>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVersion>>,
          TError,
          Awaited<ReturnType<typeof getVersion>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetVersion<TData = Awaited<ReturnType<typeof getVersion>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVersion>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVersion>>,
          TError,
          Awaited<ReturnType<typeof getVersion>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetVersion<TData = Awaited<ReturnType<typeof getVersion>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVersion>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary バージョン情報の取得
 */

export function useGetVersion<TData = Awaited<ReturnType<typeof getVersion>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVersion>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetVersionQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}
